import React from 'react';
import {AuthLayout} from 'components';
import {FormButton, Input} from 'components/ui';
import {FormProps} from 'interfaces';
// @ts-ignore
import {Message} from '@moadigitalworks/boutique-app/dist/components/ui';
import {color} from '../../styles/colors';

interface SetUpPWRenderProps extends FormProps{
	email:string
}

export default function SetUpPWRender({email,errors,submitLoading,onChangeInput,onSubmit}:SetUpPWRenderProps):JSX.Element{
	return (
		<AuthLayout>
			<>
				<h4 className='mb'>Setup password</h4>
				<p className='f-300 f-small center'>
					You have been invited to valay. Please setup a new password to manage your valet reservation
				</p>
				<form
					className='w-100 max-w-500px flex direction-column align-center pver-4'
					onSubmit={onSubmit}
				>
					<Input
						aria-readonly={true}
						aria-autocomplete='none'
						name='email'
						label = 'Email (can be changed from the dashboard)'
						placeholder='Email'
						value={email}
					/>
					<Input

						name='password'
						label = 'Set new password'
						placeholder='Password'
						type='password'
						onChange={onChangeInput}
					/>

					{!submitLoading?
						<FormButton
							className='w-100'
							color={color.get('green-valay')}
						>
							SET PASSWORD
						</FormButton>:<div/>
					}
					{errors?<div className='mt'>
						{errors.email?.required && <Message message='Email is required' color='red'/>}
						{errors.email?.pattern && <Message message='Please add a valid email' color='red'/>}
						{errors.password && <Message message='Password is required' color='red'/>}
						{errors.submitError && <Message message={errors.submitError} color='red'/>}
					</div>: null}
				</form>
			</>
		</AuthLayout>
	);
}
